import PropTypes from 'prop-types';

function ShowHeaderSection({ label, textContent, upcaseHeader = false }) {
  return (
    <div>
      <p className="text-center font-bold text-black/60 text-sm leading-4 sm:text-left">
        {label}
      </p>
      <h3 className={`text-lg ${upcaseHeader ? 'uppercase' : ''} text-black`}>
        {textContent}
      </h3>
    </div>
  );
}

ShowHeaderSection.propTypes = {
  label: PropTypes.string.isRequired,
  textContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  upcaseHeader: PropTypes.bool,
};

export default ShowHeaderSection;
